import React, { useState, useEffect } from "react";
import { Table, Button, Pagination, message, Image } from "antd";
import ContentGroupModal from "../pages/ContentGroupModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { binaryContentsHooks as cHooks } from "../hooks";

const ContentLayout = () => {
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [isGroupModalVisible, setIsGroupModalVisible] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get("page"), 10) || 1;
  const navigate = useNavigate();

  // 콘텐츠 목록 불러오기
  const fetchContents = async (page) => {
    setLoading(true);
    try {
      const res = await cHooks.UsersList({ page: page });
      console.log(res)
      setContents(res.data.data || []);
      setTotal(res.data.cnt || 0);
    } catch (error) {
      message.error("콘텐츠 목록 불러오기 실패!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContents(currentPage);
  }, [currentPage]);

  const columns = [
    {
      title: "이름",
      dataIndex: "user_name",
    },
    {
      title: "생년월일",
      dataIndex: "birth",
    },
    {
      title: "전화번호",
      dataIndex: "hp",
    },
    {
      title: "로그인 플랫폼",
      dataIndex: "login_type",
    },
    // {
    //   title: "좋아요",
    //   dataIndex: "content_like",
    // },
    {
      title: "생성일자",
      dataIndex: "created_at",
    },
    {
      title: "상세보기",
      render: (_, record) => (
        <Button
          onClick={() =>
            navigate("/users/detail", {
              state: { userData: record, page: currentPage }, // 콘텐츠 데이터를 전달
            })
          }
        >
          상세보기
        </Button>
      ),
    },
  ];

  return (
    <div>
      {/* 버튼 컨트롤 */}
      <div style={{ marginBottom: 16, display: "flex", gap: "10px" }}>
        {/* <Button type="primary" onClick={() => navigate("/contents/create")}>
          컨텐츠 생성하기
        </Button> */}
        {/* <Button onClick={() => setIsGroupModalVisible(true)}>
          컨텐츠 그룹 불러오기
        </Button> */}
      </div>

      {/* 콘텐츠 목록 */}
      <Table
        columns={columns}
        dataSource={contents}
        rowKey="id"
        loading={loading}
        pagination={false}
      />

      {/* 페이지네이션 */}
      <Pagination
        current={currentPage}
        total={total}
        pageSize={10}
        onChange={(page) => setSearchParams({ page })}
        style={{ marginTop: "20px", textAlign: "center" }}
      />

      {/* 그룹 모달 */}
      <ContentGroupModal
        visible={isGroupModalVisible}
        onClose={() => setIsGroupModalVisible(false)}
      />
    </div>
  );
};

export default ContentLayout;